var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.s.relative},[(!_vm.hasAccountAccess)?_c('ModuleBlocker'):(_vm.isMFADisabled && _vm.activeAccountId !== 'DEMOACC')?_c('ModuleBlocker',{attrs:{"need-set-up-t-f-a":""}}):_vm._e(),(_vm.placements.length > 0)?_c('TransferContent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }